export default "__VITE_ASSET__CtuT$Wh8__"